import React, { useState } from 'react';
import { Image, Modal } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { getBase64 } from './utils/getBase64';

export interface ImageUploadReviewProps {
  previewWidth?: number;
  fileList?: UploadFile<unknown>[];
}

export const ImageUploadReview: React.FC<ImageUploadReviewProps> = ({ previewWidth, fileList }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState<string | ArrayBuffer | null>('');

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file: UploadFile) => {
    if (file.originFileObj) {
      setPreviewImage(await getBase64(file.originFileObj));
      setPreviewVisible(true);
    }
  };

  return (
    <>
      {fileList?.map(image => (
        <Image
          key={image.uid}
          preview={{ visible: false }}
          src={image.thumbUrl}
          style={{ padding: 5 }}
          width={previewWidth ?? 100}
          onClick={() => handlePreview(image)}
        />
      ))}
      <Modal footer={null} open={previewVisible} title={null} onCancel={handleCancel}>
        <img alt="preview" className="w-100" src={typeof previewImage === 'string' ? previewImage : ''} />
      </Modal>
    </>
  );
};
